export const SetConfigurationController = ($scope,
                                              $mdDialog,
                                              callback
                                              ) => {
    "ngInject";

    $scope.callback = callback;
    // $scope.configurationsArray = configurationsArray;
    // $scope.deployment = activeDeployment;

    // $scope.filteredConfig = cloneDeep(filter($scope.configurationsArray, (c) => {
    //     return includes($scope.deployment.configurations, c.url);
    // }));

    $scope.configObjects = {
          config: null
    };

    $scope.closeDialog = () => {
        $mdDialog.hide();
    };

    $scope.create = () => {
        callback($scope.configObjects);
        document.onkeypress = () => {};
        $mdDialog.hide();
    };

    document.onkeypress = (ev) => {
        if (ev.key === "Enter") {
            if ($scope.configObjects.config) {
                $scope.create();
            }
        }
    };
};


// WEBPACK FOOTER //
// ./sources/components/booths/set-configuration/set-configuration.js